export const sanitizeServiceUrl = (rawUrl) => {
  if (typeof rawUrl !== 'string') return '';

  const trimmed = rawUrl.trim();
  if (!trimmed) return '';

  try {
    const parsed = new URL(trimmed);
    const hasTrailingSlashInInput = trimmed.endsWith('/');
    const pathname =
      parsed.pathname === '/' && !hasTrailingSlashInInput
        ? ''
        : parsed.pathname;
    return `${parsed.origin}${pathname}${parsed.hash}`;
  } catch (error) {
    const [beforeHash, hashFragment] = trimmed.split('#');
    const base = beforeHash.split('?')[0];
    return hashFragment ? `${base}#${hashFragment}` : base;
  }
};

export const sanitizeServiceUrls = (value) => {
  if (!Array.isArray(value)) return value;

  return value.map((entry) => {
    if (typeof entry === 'string') {
      return sanitizeServiceUrl(entry);
    }

    if (entry && typeof entry === 'object') {
      const sanitizedUrl = sanitizeServiceUrl(entry.url ?? '');
      if (sanitizedUrl === (entry.url ?? '')) {
        return entry;
      }

      return {
        ...entry,
        url: sanitizedUrl,
      };
    }

    return entry;
  });
};

export const getSanitizedUrlFromEntry = (entry) => {
  if (typeof entry === 'string') {
    return sanitizeServiceUrl(entry);
  }

  if (entry && typeof entry === 'object') {
    return sanitizeServiceUrl(entry.url ?? '');
  }

  return '';
};
